module.exports = __webpack_public_path__ + "static/media/Icn-svg.115efd16.svg";